<template>
  <div :style="`width:${dispW - 2}px;height:${dispH}px;position:relative`">
    <AxisIndication
      :rightsider="fixRightAsider"
      :dispH="dispH / 2 - 80"
      :url="originUrl"
      :origImgPath="origImgPath"
      :qs="qs"
      :isQVisible="isQVisible"
      @show-qs="isVisibleBoolen = true"
    ></AxisIndication>
    <el-divider></el-divider>
    <CorneaParam :mapValues="mapValues" :rightsider="corneaParamAsider" :subPage="subPage" />
    <QS :qs="qs" :isVisible.sync="isVisibleBoolen" />
  </div>
</template>
<script>
import CorneaParam from "./CorneaParam.vue";
import AxisIndication from "./AxisIndication";
import QS from "../pages/dialog-forms/QS";
import { getFilePath, FILES, isFileExists } from "../shared";
export default {
  name: "RightAsider",
  data: function () {
    return {
      originUrl: "",
      fixRightAsider: {
        isMapBoolen: false,
        isScaleBoolen: false,
        isImageBoolen: true
      },
      corneaParamAsider: {
        isMapBoolen: false,
        isScaleBoolen: true,
        isImageBoolen: false
      },
      isVisibleBoolen: false,
      origImgPath: ""
    };
  },
  components: {
    CorneaParam,
    AxisIndication,
    QS
  },
  created: function () {
    let _orgPath = getFilePath(this.$store.state.topography.casePath, FILES.originImageTh);
    this.originUrl = `file://${_orgPath}?t=${Math.random()}`;
    if (!isFileExists(_orgPath)) {
      this.originUrl = "";
    }
  },
  mounted: function () {
    this.origImgPath = getFilePath(this.$store.state.topography.casePath, FILES.originImage);
  },
  methods: {
    showQS() {
      this.isVisibleBoolen = true;
    }
  },
  props: {
    dispW: {
      type: Number,
      default: 500
    },
    dispH: {
      type: Number,
      default: window.screen.height - 70
    },
    rightsider: Object,
    allparams: {
      type: Object
    },
    mapValues: {
      type: Object
    },
    qs: {
      type: Array,
      default() {
        return [{ color: "red", label: "txtFailed" }];
      }
    },
    isQVisible: false,
    subPage: ""
  },
  computed: {
    qualityClass() {
      return `quality-${this.qs[this.qs.length - 1].color}`;
    },
    label() {
      return this.$t(`langcfg.${this.qs[this.qs.length - 1].label}`);
    }
  },
  watch: {}
};
</script>
<style scoped>
.el-row {
  margin-top: 24px;
}
.quality-red {
  color: red;
}
.quality-yellow {
  color: yellow;
}
.quality-green {
  color: green;
}
</style>



// WEBPACK FOOTER //
// src/topography/components/RightAsider.vue